import { render, staticRenderFns } from "./AuctionSold.vue?vue&type=template&id=f52cd5c4&scoped=true&"
import script from "./AuctionSold.vue?vue&type=script&lang=js&"
export * from "./AuctionSold.vue?vue&type=script&lang=js&"
import style0 from "./AuctionSold.vue?vue&type=style&index=0&id=f52cd5c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52cd5c4",
  null
  
)

export default component.exports